import DataTable from 'components/Display/DataTable/DataTable'
import {Page, PageContent} from 'components/Page'
import {
    useDeletePublicationFolderMutation,
    useGetPublicationFoldersQuery,
} from 'store/slices/api/publicationFoldersApi'

const PublicationFolders = () => {
    return (
        <Page>
            <PageContent>
                <DataTable
                    allowEdit
                    allowDelete
                    confirmBeforeDelete
                    itemName="publicationFolder"
                    paginationType="external"
                    useGetQuery={useGetPublicationFoldersQuery}
                    useDeleteMutation={useDeletePublicationFolderMutation}
                />
            </PageContent>
        </Page>
    )
}

export default PublicationFolders
